import React from "react";
import { useForm } from "@inertiajs/react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Link } from "@inertiajs/react";

export default function Forgot() {
  const { data, setData, post, processing } = useForm({
    email_address: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post("/passwords");
  };

  return (
    <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
          Mot de passe oublié
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email_address" className="block text-sm font-medium text-gray-700">
                Adresse email
              </label>
              <div className="mt-1">
                <Input
                  id="email_address"
                  name="email_address"
                  type="email"
                  autoComplete="email"
                  required
                  value={data.email_address}
                  onChange={e => setData("email_address", e.target.value)}
                />
              </div>
            </div>

            <div>
              <Button
                type="submit"
                className="w-full"
                disabled={processing}
              >
                {processing ? "Envoi en cours..." : "Envoyer les instructions"}
              </Button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <Link
              href="/session/new"
              className="text-sm font-medium text-[#008788] hover:text-[#00bcbe]"
            >
              Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
